import * as React from "react";
import MuiButton from "@material-ui/core/Button";
import type { UiBaseProps, UiElement } from "../uiProps.utils";

export enum ButtonVariant {
  TEXT = "text",
  OUTLINED = "outlined",
  CONTAINED = "contained",
}

export enum ButtonColor {
  DEFAULT = "default",
  PRIMARY = "primary",
  INHERIT = "inherit",
}

export enum ButtonSize {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}

export type ButtonProps = UiBaseProps & {
  variant?: ButtonVariant;
  color?: ButtonColor;
  size?: ButtonSize;
  startIcon?: React.ReactNode;
  disabled?: boolean;
  fullWidth?: boolean;
  // No drop shadow on a contained button.
  flat?: boolean;
  // "label" makes the whole button open a hidden file input placed inside it.
  as?: UiElement;
  title?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
};

export const Button: React.FC<ButtonProps> = ({ flat, as, ...rest }) => (
  <MuiButton disableElevation={flat} {...(as ? { component: as as React.ElementType } : {})} {...rest} />
);
